import React from 'react';
import { useNavigate } from 'react-router-dom';

interface QuickActionsProps {
  userRole: string;
}

const QuickActions: React.FC<QuickActionsProps> = ({ userRole }) => {
  const navigate = useNavigate();

  const getActionsForRole = () => {
    const actions = [];

    switch (userRole) {      case 'manager':
        actions.push(
          {
            title: 'Manage Users',
            description: 'Add, edit, or manage user accounts',
            icon: 'U',
            color: 'bg-blue-500 hover:bg-blue-600',
            action: () => navigate('/users')
          },
          {
            title: 'View Reports',
            description: 'Access system reports and analytics',
            icon: 'R',
            color: 'bg-green-500 hover:bg-green-600',
            action: () => navigate('/reports')
          },
          {
            title: 'Inventory Management',
            description: 'Manage inventory and stock levels',
            icon: 'I',
            color: 'bg-purple-500 hover:bg-purple-600',
            action: () => navigate('/inventory')
          },
          {
            title: 'Style Management',
            description: 'Add and manage product styles',
            icon: 'S',
            color: 'bg-pink-500 hover:bg-pink-600',
            action: () => navigate('/styles')
          },
          {
            title: 'Order Verification',
            description: 'Verify completed orders',
            icon: 'V',
            color: 'bg-orange-500 hover:bg-orange-600',
            action: () => navigate('/order-verification')
          }
        );
        break;

      case 'executive1':
        actions.push(
          {
            title: 'Order Management',
            description: 'Process and assign orders',
            icon: 'O',
            color: 'bg-blue-500 hover:bg-blue-600',
            action: () => navigate('/orders')
          },
          {
            title: 'Upload Orders',
            description: 'Upload daily order files',
            icon: 'F',
            color: 'bg-green-500 hover:bg-green-600',
            action: () => navigate('/orders/upload')
          },
          {
            title: 'View Inventory',
            description: 'Check current stock levels',
            icon: 'I',
            color: 'bg-purple-500 hover:bg-purple-600',
            action: () => navigate('/inventory')
          }
        );
        break;

      case 'executive2':
        actions.push(
          {
            title: 'Stock Approval',
            description: 'Approve and manage new stock',
            icon: '✓',
            color: 'bg-green-500 hover:bg-green-600',
            action: () => navigate('/stock-approval')
          },
          {
            title: 'Order Verification',
            description: 'Verify completed orders',
            icon: 'V',
            color: 'bg-blue-500 hover:bg-blue-600',
            action: () => navigate('/order-verification')
          },
          {
            title: 'Style Upload',
            description: 'Upload Shopify style catalog',
            icon: 'S',
            color: 'bg-pink-500 hover:bg-pink-600',
            action: () => navigate('/styles/upload')
          }
        );
        break;

      case 'worker':
        actions.push(
          {
            title: 'My Orders',
            description: 'View and pick assigned orders',
            icon: 'O',
            color: 'bg-blue-500 hover:bg-blue-600',
            action: () => navigate('/order-picking')
          },
          {
            title: 'Inventory Search',
            description: 'Find item locations',
            icon: '?',
            color: 'bg-green-500 hover:bg-green-600',
            action: () => navigate('/inventory/search')
          }
        );
        break;

      default:
        actions.push(
          {
            title: 'Getting Started',
            description: 'Learn how to use the system',
            icon: 'H',
            color: 'bg-gray-500 hover:bg-gray-600',
            action: () => {}
          }
        );
    }

    return actions;
  };

  const actions = getActionsForRole();

  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">Quick Actions</h3>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {actions.map((action, index) => (            <button
              key={index}
              onClick={action.action}
              className={`${action.color} text-white rounded-lg p-4 text-left transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
            >
              <div className="flex items-center">
                <div className="w-10 h-10 bg-white bg-opacity-20 rounded-md flex items-center justify-center mr-3">
                  <span className="text-lg font-bold text-white">
                    {action.icon}
                  </span>
                </div>
                <div>
                  <h4 className="text-sm font-medium">{action.title}</h4>
                  <p className="text-xs opacity-90 mt-1">{action.description}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickActions;
